import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { api_url } from "../../utils/utils";

export const get_hospital_dashboard_index_data = createAsyncThunk(
  "dashboardIndex/get_hospital_dashboard_index_data",
  async (_, { rejectWithValue, fulfillWithValue, getState }) => {
    const token = getState().auth.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const { data } = await axios.get(
        `${api_url}/api/hospital/get-dashboard-index-data`,
        config
      );
      console.log(data, "data");
      return fulfillWithValue(data);
    } catch (error) {
      console.log(error, "error");
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_admin_dashboard_index_data = createAsyncThunk(
  "dashboardIndex/get_admin_dashboard_index_data",
  async (_, { rejectWithValue, fulfillWithValue, getState }) => {
    const token = getState().auth.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const { data } = await axios.get(
        `${api_url}/api/admin/get-dashboard-index-data`,
        config
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createHealthCard = createAsyncThunk(
  "dashboardIndex/createHealthCard",
  async (info, { fulfillWithValue, rejectWithValue, getState }) => {
    const token = getState().auth.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const { data } = await axios.post(`${api_url}/api/home/create-health-card`, info, config);
      console.log(data, "data")
      return fulfillWithValue(data);
    } catch (error) {
      console.log(error)
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



export const get_card = createAsyncThunk(
  "blog/get_card ",
  async (cardId, { rejectWithValue, fulfillWithValue, getState }) => {
    console.log(cardId, "id");
    const token = getState().auth.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const { data } = await axios.get(
        `${api_url}/api/home/get-card/${cardId}`,
        config
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);



export const get_single_user = createAsyncThunk(
  "blog/get_single_user ",
  async (userId, { rejectWithValue, fulfillWithValue, getState }) => {
    console.log(userId, "id");
    const token = getState().auth.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const { data } = await axios.get(
        `${api_url}/api/home/get-single-user/${userId}`,
        config
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const update_card = createAsyncThunk(
  'card/update_card',
  async (card, { rejectWithValue, fulfillWithValue, getState }) => {
    const token = getState().auth.token
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }
    try {
      const { data } = await axios.post(`${api_url}/api/home/card-update`, card, config)
      return fulfillWithValue(data)
    } catch (error) {
      console.log(error)
      return rejectWithValue(error.response.data)
    }
  }
)

export const card_status_update = createAsyncThunk(
  "card/card_status_update",
  async (info, { rejectWithValue, fulfillWithValue, getState }) => {
    console.log(info, "info status update")
    const token = getState().auth.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const { data } = await axios.post(
        `${api_url}/api/home/card-status-update`,
        info,
        config
      );

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const dashboardIndexReducer = createSlice({
  name: "dashboardIndex",
  initialState: {
    totalPendingAppoinment: 0,
    totalAppoinment: 0,
    totalDoctor: 0,
    completeAppoinment: 0,
    recentAppoinments: [],
    totalHospital: 0,
    totalUser: 0,
    loading: false,
    card: {},
    user:{}
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [get_hospital_dashboard_index_data.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [get_hospital_dashboard_index_data.fulfilled]: (state, { payload }) => {
      state.totalDoctor = payload.totalDoctor;
      state.totalAppoinment = payload.totalAppoinment;
      state.completeAppoinment = payload.totalCompleteAppoinment;
      state.totalPendingAppoinment = payload.totalPendingAppoinment;
      state.recentAppoinments = payload.recentAppoinments;
      state.loading = false;
    },
    [get_hospital_dashboard_index_data.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [get_admin_dashboard_index_data.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [get_admin_dashboard_index_data.fulfilled]: (state, { payload }) => {
      state.totalDoctor = payload.totalDoctor;
      state.totalAppoinment = payload.totalAppoinment;
      state.totalHospital = payload.totalHospital;
      state.recentAppoinments = payload.recentAppoinments;
      state.totalUser = payload.totalUser;
      state.loading = false;
    },
    [get_admin_dashboard_index_data.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [createHealthCard.pending]: (state, { payload }) => {
      state.loading = true;
      state.successMessage = null;
      state.errorMessage = null;
    },
    [createHealthCard.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.successMessage = payload.message;
    },
    [createHealthCard.rejected]: (state, { payload }) => {
      state.loading = false;
      state.errorMessage = payload.error;
    },
    [get_card.pending]: (state, _) => {
      state.loader = true;
    },
    [get_card.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },
    [get_card.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.card = payload.card;
    },
    [get_single_user.pending]: (state, _) => {
      state.loader = true;
    },
    [get_single_user.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },
    [get_single_user.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.user = payload.user;
    },
    [update_card.pending]: (state, _) => {
      state.loader = true
    },
    [update_card.rejected]: (state, { payload }) => {
      state.loader = false
      state.errorMessage = payload.error
    },
    [update_card.fulfilled]: (state, { payload }) => {
      state.loader = false
      state.card = payload.card
      state.successMessage = payload.message
    },
    [card_status_update.fulfilled]: (state, { payload }) => {
      state.card = payload.card;
      state.successMessage = payload.message;
    },
  },
});
export const { messageClear } = dashboardIndexReducer.actions;
export default dashboardIndexReducer.reducer;
